import React from 'react';
import {Grid, Select, MenuItem, InputLabel,FormControl,} from '@material-ui/core'
import IntlMessages from 'util/IntlMessages';

function ChartTypeSettings(props) {
    return (
        <Grid item xs="12">
        <FormControl variant='outlined' fullWidth size='small'>
          <InputLabel id="demo-simple-select-label"><IntlMessages id="Charttyp"/></InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Intervall"
              value={props.chartType}
              onChange={(e) => props.setchartType(e.target.value)}
            >
              <MenuItem value={""}><IntlMessages id="Choose"/></MenuItem>
              <MenuItem value={"ColumnChart"}><IntlMessages id="Bar"/></MenuItem>
              <MenuItem value={"PieChart"}><IntlMessages id="PieChart"/></MenuItem>
              <MenuItem value={"DonutChart"}><IntlMessages id="DonutChart"/></MenuItem>
            </Select>
          </FormControl>
        </Grid>
    );
}

export default ChartTypeSettings;